// Scans raw head_scripts HTML for well-known tracking / advertising tags
// and reports what was detected (with IDs) so the admin can verify the paste.

const DETECTORS = [
  {
    key: "ga4",
    label: "Google Analytics 4",
    re: /['"](G-[A-Z0-9]{4,16})['"]/,
    hint: "Looks for gtag('config','G-…')",
  },
  {
    key: "gtm",
    label: "Google Tag Manager",
    re: /['"](GTM-[A-Z0-9]{4,10})['"]/,
  },
  {
    key: "gads",
    label: "Google Ads",
    re: /['"](AW-\d{5,12})['"]/,
  },
  {
    key: "ua",
    label: "Universal Analytics (legacy)",
    re: /['"](UA-\d{4,10}-\d{1,4})['"]/,
    legacy: true,
  },
  {
    key: "adsense",
    label: "Google AdSense",
    re: /(ca-pub-\d{10,20})/,
  },
  {
    key: "fb",
    label: "Meta (Facebook) Pixel",
    re: /fbq\s*\(\s*['"]init['"]\s*,\s*['"](\d{10,20})['"]/,
  },
  {
    key: "x",
    label: "X / Twitter Pixel",
    re: /twq\s*\(\s*['"]config['"]\s*,\s*['"]([a-z0-9]+)['"]/i,
  },
  {
    key: "hotjar",
    label: "Hotjar",
    re: /hjid\s*[:=]\s*(\d+)/,
  },
  {
    key: "clarity",
    label: "Microsoft Clarity",
    re: /clarity\.ms\/tag\/([a-z0-9]+)/i,
  },
  {
    key: "linkedin",
    label: "LinkedIn Insight",
    re: /_linkedin_partner_id\s*=\s*['"]?(\d+)['"]?/,
  },
  {
    key: "tiktok",
    label: "TikTok Pixel",
    re: /ttq\.load\s*\(\s*['"]([A-Z0-9]+)['"]/,
  },
];

// Generic sniffers — no ID captured, just presence
const GENERIC_SIGNALS = [
  { key: "gtag-js", label: "gtag.js loader", re: /googletagmanager\.com\/gtag\/js/i },
  { key: "gtm-js", label: "GTM loader", re: /googletagmanager\.com\/gtm\.js/i },
  { key: "adsense-js", label: "AdSense loader", re: /pagead2\.googlesyndication\.com\/pagead\/js\/adsbygoogle/i },
  { key: "fbevents", label: "fbevents.js loader", re: /connect\.facebook\.net\/.*fbevents\.js/i },
];

export function detectTags(html) {
  const detected = [];
  if (!html || !html.trim()) return detected;

  for (const d of DETECTORS) {
    const m = html.match(d.re);
    if (m) {
      detected.push({
        key: d.key,
        label: d.label,
        id: m[1],
        legacy: !!d.legacy,
      });
    }
  }
  // Generic signals only if not already matched
  for (const g of GENERIC_SIGNALS) {
    if (g.re.test(html) && !detected.find((d) => d.key.startsWith(g.key.split("-")[0]))) {
      detected.push({ key: g.key, label: g.label, id: null });
    }
  }
  return detected;
}
